export class CovenantUser {

    id: number;
    name: string;
    role: string;
    email: string;
    active: boolean;

    constructor() { }
}